var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var separator = '|';
var boolPrefix = 'b~';
var boolTrue = 'b~true';
var numberPrefix = 'n~';
var escapeRegex = /\|\~/g;
var escapeSubstitute = '_';
var Bucket = /** @class */ (function () {
    function Bucket() {
        this.count = 0;
        this.measureSums = new Map();
    }
    return Bucket;
}());
var LoggingAggregator = /** @class */ (function () {
    function LoggingAggregator(eventName, condition, dimensions, avgMeasures, intervalSec) {
        var _this = this;
        this.buckets = new Map();
        this.init = function (log) {
            _this.log = log;
        };
        /* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
        this.add = function (obj) {
            var e_1, _a, e_2, _b, e_3, _c;
            if (!_this.condition || !_this.condition(obj)) {
                _this.log(obj, false /*isAggregated*/);
                return;
            }
            var bucketParams = [];
            try {
                for (var _d = __values(_this.dimensions), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var dimension = _e.value;
                    if (obj[dimension] === undefined) {
                        bucketParams.push(null);
                    }
                    else {
                        var prefix = '';
                        if (typeof obj[dimension] == 'boolean') {
                            prefix = boolPrefix;
                        }
                        else if (typeof obj[dimension] == 'number') {
                            prefix = numberPrefix;
                        }
                        bucketParams.push("".concat(prefix).concat(obj[dimension].toString()
                            .replace(escapeRegex, escapeSubstitute)));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var bucketKey = bucketParams.join(separator);
            var bucket = _this.buckets.get(bucketKey);
            if (!bucket) {
                bucket = new Bucket();
                bucket.traceLevel = obj.traceLevel;
                try {
                    for (var _f = __values(_this.avgMeasures), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var avgMeasure = _g.value;
                        bucket.measureSums.set(avgMeasure, 0);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                _this.buckets.set(bucketKey, bucket);
            }
            bucket.count++;
            try {
                for (var _h = __values(_this.avgMeasures), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var avgMeasure = _j.value;
                    if (obj[avgMeasure]) {
                        bucket.measureSums.set(avgMeasure, bucket.measureSums.get(avgMeasure) + obj[avgMeasure]);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        this.flush = function (stop) {
            if (stop === void 0) { stop = false; }
            _this.buckets.forEach(function (bucket, bucketKey) {
                var e_4, _a;
                var obj = {
                    traceLevel: bucket.traceLevel,
                    eventName: _this.eventName,
                    count: bucket.count
                };
                var bucketParams = bucketKey.split(separator);
                for (var i = 0; i < _this.dimensions.length; i++) {
                    var dimension = _this.dimensions[i];
                    var dimensionValue = bucketParams[i];
                    if (dimensionValue.indexOf(boolPrefix) === 0) {
                        obj[dimension] = (dimensionValue === boolTrue);
                    }
                    else if (dimensionValue.indexOf(numberPrefix) === 0) {
                        obj[dimension] = parseInt(dimensionValue.slice(numberPrefix.length), 10); // Tracelogger only supports ints for now...
                    }
                    else {
                        obj[dimension] = dimensionValue;
                    }
                }
                try {
                    for (var _b = __values(_this.avgMeasures), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var avgMeasure = _c.value;
                        obj[avgMeasure] = Math.round(bucket.measureSums.get(avgMeasure) / bucket.count); // Tracelogger only supports ints for now...
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                _this.log(obj, true /*isAggregated*/);
            });
            _this.buckets.clear();
            if (stop) {
                _this.condition = null;
                clearInterval(_this.interval);
            }
        };
        this.eventName = eventName;
        this.condition = condition;
        this.dimensions = dimensions;
        this.avgMeasures = avgMeasures;
        if (intervalSec > 0) {
            this.interval = setInterval(this.flush, intervalSec * 1000);
        }
        // If no interval is set, caller must flush manually
    }
    return LoggingAggregator;
}());
export { LoggingAggregator };
//# sourceMappingURL=logging-aggregator.js.map